import { useState, useLayoutEffect } from 'react';

const useDropdownPosition = (anchorRef, isOpen, maxHeight = 300, gap = 4) => {
  const [position, setPosition] = useState(null);

  useLayoutEffect(() => {
    if (!isOpen || !anchorRef.current) return;

    const calculatePosition = () => {
      const rect = anchorRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      
      const openUpward = spaceBelow < maxHeight && spaceAbove > spaceBelow;

      setPosition({
        left: rect.left,
        top: openUpward ? null : rect.bottom + gap,
        bottom: openUpward ? window.innerHeight - rect.top + gap : null,
        width: rect.width,
        openUpward,
      });
    };

    calculatePosition();

  }, [anchorRef, isOpen, maxHeight, gap]); 

  return position;
};

export default useDropdownPosition;